import React from 'react';

const termsSections = [
  {
    title: '1. Назначение сайта',
    paragraphs: [
      'Сайт dririnalazareva.com предоставляет информацию о психологических услугах, профессиональной деятельности специалиста и возможностях получения консультации.',
      'Информация, размещенная на сайте, носит исключительно ознакомительный и информационный характер.',
      'Материалы сайта не являются заменой индивидуальной психологической или медицинской консультации.'
    ]
  },
  {
    title: '2. Отсутствие терапевтических отношений через сайт',
    paragraphs: [
      'Использование сайта, включая отправку сообщений через контактную форму, не создает автоматических отношений психолог клиент.',
      'Психологическая консультация считается начатой только после согласования условий и проведения индивидуальной встречи или сессии.'
    ]
  },
  {
    title: '3. Использование информации сайта',
    intro: 'Пользователи могут использовать материалы сайта только в личных некоммерческих целях.',
    note: 'Запрещается:',
    items: [
      'копирование материалов сайта без разрешения',
      'распространение текстов или изображений сайта',
      'использование материалов сайта в коммерческих целях без письменного согласия владельца сайта'
    ],
  },
  {
    title: '4. Интеллектуальная собственность',
    paragraphs: [
      'Все материалы сайта, включая тексты, изображения, дизайн, графику и структуру сайта, являются объектами авторского права и защищены законодательством.',
      'Любое использование материалов без разрешения правообладателя запрещено.'
    ]
  },
  {
    title: '5. Ограничение ответственности',
    paragraphs: [
      'Администрация сайта стремится предоставлять точную и актуальную информацию, однако не гарантирует ее полноту или актуальность.',
      'Пользователь принимает решение об использовании информации сайта самостоятельно.',
      'Сайт не несет ответственности за любые последствия, связанные с использованием информации, размещенной на сайте.'
    ]
  },
  {
    title: '6. Ссылки на сторонние ресурсы',
    paragraphs: [
      'На сайте могут размещаться ссылки на сторонние интернет ресурсы.',
      'Администрация сайта не контролирует содержание таких ресурсов и не несет ответственности за их работу или политику конфиденциальности.'
    ]
  },
  {
    title: '7. Использование контактной формы',
    paragraphs: [
      'При использовании контактной формы пользователь обязуется предоставлять достоверную информацию.'
    ],
    note: 'Запрещается использовать форму для:',
    items: [
      'рассылки спама',
      'передачи вредоносных материалов',
      'отправки незаконного или оскорбительного контента'
    ],
  },
  {
    title: '8. Изменения условий',
    paragraphs: [
      'Администрация сайта оставляет за собой право изменять настоящие Условия использования в любое время.',
      'Актуальная версия условий публикуется на данной странице сайта.'
    ]
  }
];

const TermsAndConditionsPage = () => {
  return (
    <div>
      <section className="bg-teal-700 py-16 md:py-20">
        <div className="container mx-auto px-6">
          <div className="text-center text-white">
            <p className="mb-2 text-xs font-medium uppercase tracking-[0.3em] text-sand-200">
              Документы
            </p>
            <h1 className="text-4xl font-serif md:text-5xl">
              Условия использования сайта
            </h1>
            <p className="mx-auto mt-4 max-w-3xl text-sand-100">
              Условия, регулирующие доступ, использование материалов сайта и работу с его сервисами
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white py-16 md:py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl space-y-8">
            <div>
              <p className="mb-3 text-sm font-medium uppercase tracking-wide text-teal-600">
                О документе
              </p>
              <h2 className="max-w-5xl text-3xl font-serif leading-tight text-stone-800 md:text-4xl">
                Ознакомьтесь с правилами использования сайта и условиями доступа к размещённой на нём информации
              </h2>
            </div>

            <div className="max-w-5xl space-y-6 text-lg leading-relaxed text-stone-600">
              <p>
                Используя данный сайт, вы подтверждаете, что ознакомились с настоящими условиями и соглашаетесь соблюдать их.
              </p>
            </div>

            <div className="max-w-5xl space-y-10 pt-4">
              {termsSections.map((section) => (
                <section key={section.title} className="space-y-4">
                  <h3 className="text-2xl font-serif text-stone-800">
                    {section.title}
                  </h3>

                  {section.intro ? (
                    <p className="text-lg leading-relaxed text-stone-600">
                      {section.intro}
                    </p>
                  ) : null}

                  {section.paragraphs?.map((paragraph) => (
                    <p key={paragraph} className="text-lg leading-relaxed text-stone-600">
                      {paragraph}
                    </p>
                  ))}

                  {section.items?.length ? (
                    <ul className="list-disc space-y-3 pl-6 text-lg leading-relaxed text-stone-600 marker:text-teal-600">
                      {section.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  ) : null}

                  {section.outro ? (
                    <p className="text-lg leading-relaxed text-stone-600">
                      {section.outro}
                    </p>
                  ) : null}

                  {section.note ? (
                    <p className="text-lg leading-relaxed text-stone-600">
                      {section.note}
                    </p>
                  ) : null}
                </section>
              ))}

              <section className="space-y-4">
                <h3 className="text-2xl font-serif text-stone-800">
                  9. Контактная информация
                </h3>
                <p className="text-lg leading-relaxed text-stone-600">
                  По вопросам, связанным с использованием сайта, вы можете связаться через контактную форму на сайте:
                </p>
                <div className="space-y-2 text-lg leading-relaxed text-stone-600">
                  <p>
                    <a
                      href="https://dririnalazareva.com"
                      className="text-teal-600 transition-colors hover:text-teal-700"
                    >
                      https://dririnalazareva.com
                    </a>
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditionsPage;
